import { makeObservable, observable, action } from 'mobx';
import UIStore from './UIStore';

class GlobalStore {
  isLoading = false;
  loadingMessage = '';
  enabledRecaptchaV2 = false;
  tokenRecaptchaV2: string | undefined = undefined;
  confirmRegistrationDialogOpened = false;

  // zp extensions (Task 0.5)
  maintenanceDesc: string | null = null;
  countdownExpireToken: string = '';
  confirmationDialogName?: string = undefined;

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      loadingMessage: observable,
      enabledRecaptchaV2: observable,
      confirmRegistrationDialogOpened: observable,
      maintenanceDesc: observable,
      countdownExpireToken: observable,
      confirmationDialogName: observable,
      loading: action,
      openConfirmRegistrationDialog: action,
      closeConfirmRegistrationDialog: action,
      setEnabledRecaptchaV2: action,
      openConfirmationDialog: action,
      closeConfirmationDialog: action,
      setMaintenanceDesc: action
    });
  }

  loading = (isLoading: boolean, message = '') => {
    this.isLoading = isLoading;
    this.loadingMessage = message;
  };

  setEnabledRecaptchaV2 = (enabled: boolean) => (this.enabledRecaptchaV2 = enabled);
  openConfirmRegistrationDialog = () => (this.confirmRegistrationDialogOpened = true);
  closeConfirmRegistrationDialog = () => (this.confirmRegistrationDialogOpened = false);

  openConfirmationDialog = (name: string) => (this.confirmationDialogName = name);
  closeConfirmationDialog = () => (this.confirmationDialogName = undefined);
  setMaintenanceDesc = (desc: string | null) => (this.maintenanceDesc = desc);

  // proxy na notifikácie (zachováva volania zp `GlobalStore.setNotificationMessage(msg, "", variant)`)
  setNotificationMessage = (
    message: string,
    _data: string = '',
    variant: 'default' | 'success' | 'warning' | 'error' = 'default'
  ) => UIStore.setNotificationMessage(message, variant);
}
const singleton = new GlobalStore();
export default singleton;
